// "Zuletzt verwendet" (Equipment): echte Nutzungshistorie des Users (recency.js, Backlog D3) —
// ersetzt die fruehere Fixture-Attrappe auf dem Home. Sitzt unter der Suche (Home + beide
// Anlege-Wizards); gefiltert auf das AKTIVE Werk (ein 4380-Geraet gehoert nicht in einen
// 4370-Auftrag); verschwindet komplett, solange es keine Historie gibt (ehrlich statt Attrappe).
import React, { useEffect, useState } from 'react';
import { ChevronRight, History } from 'lucide-react';
import { useTheme } from '../../../core/ui/ThemeContext';
import { useLanguage } from '../../../core/i18n/LanguageContext';
import { getRecent, recordRecent } from '../recency';
import { Card } from './ui';

/**
 * @param {Object} me — activePlant fuer den Werksfilter
 * @param {Function} onSelect — (equipment) => void; Klick bumpt zusaetzlich die Recency
 * @param {number} [max]
 */
function RecentEquipmentList({ user, me, onSelect, max = 10 }) {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    getRecent(user, 'equipment').then((list) => { if (alive) setItems(list); });
    return () => { alive = false; };
  }, [user, me]);

  const visible = items.filter((e) => !e.plant || e.plant === me.activePlant).slice(0, max);
  if (visible.length === 0) return null;

  const pick = (eq) => {
    recordRecent(user, 'equipment', eq, 'equipmentId'); // bump, fire-and-forget
    onSelect(eq);
  };

  return (
    <section>
      <h2 className={`flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wide mb-2 ${isDarkMode ? 'text-white/50' : 'text-slate-500'}`}>
        <History size={14} /> {t('pm.recent.title')}
      </h2>
      <div className="space-y-2">
        {visible.map((eq) => (
          <button key={eq.equipmentId} onClick={() => pick(eq)} className="w-full text-left">
            <Card className="flex items-center justify-between !p-3">
              <div className="min-w-0">
                <div className={`font-semibold truncate ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>{eq.description}</div>
                <div className={`text-sm ${isDarkMode ? 'text-white/60' : 'text-slate-500'}`}>
                  {eq.equipmentId}{eq.functionalLocation ? ` · ${eq.functionalLocation}` : ''}
                </div>
              </div>
              <ChevronRight className={`shrink-0 ${isDarkMode ? 'text-white/40' : 'text-slate-400'}`} />
            </Card>
          </button>
        ))}
      </div>
    </section>
  );
}

export default RecentEquipmentList;
